import React from 'react';
import { IconPath, Image, TextField } from 'cw-ui-core';
import css from './TextBoxList.scss';
import cx from 'classnames';
import IconTextButton from 'src/components/IconTextButton/IconTextButton';
import RenderIfHasPermissions from 'src/components/RenderIfHasPermissions/RenderIfHasPermissions';
import { PERMISSIONS } from 'src/constants';

const TextBoxList = ({ items, itemDeleted, itemChanged, focusChange, disabled, buttonText, itemAdded }) => {
    const getList = () => {
        if (items == null) {
            return null;
        }
        return items.map((item, index) => (
            <div className={css.wrapListItem} key={`textBoxListItems_${index}`}>
                <RenderIfHasPermissions
                    requiredPermissions={[PERMISSIONS.AUTHENTICATION_UPDATE]}
                    allowIfAnyOneOfPermissionPresent>
                    <Image
                        src={IconPath.get('Action_Close')}
                        className={css.delete}
                        onClick={() => itemDeleted(index)}
                    />
                </RenderIfHasPermissions>
                <TextField
                    value={item}
                    className={cx(css.textField, css.inputField)}
                    onChange={text => itemChanged(index, text)}
                    onFocus={() => focusChange(index)}
                    onBlur={() => focusChange(null)}
                    disabled={disabled}
                />
            </div>
        ));
    };

    return (
        <div className={css.wrap}>
            <RenderIfHasPermissions
                requiredPermissions={[PERMISSIONS.AUTHENTICATION_UPDATE]}
                allowIfAnyOneOfPermissionPresent>
                <div className={css.button}>
                    <IconTextButton
                        automationName="iconTextURI"
                        icon={IconPath.get('Action_AddNew')}
                        text={buttonText}
                        onClick={itemAdded}
                    />
                </div>
            </RenderIfHasPermissions>
            {getList()}
        </div>
    );
};

export default TextBoxList;
